var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooltiphover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 8.13636C12.4332 8.13636 9.13636 11.4332 9.13636 15.5C9.13636 19.5668 12.4332 22.8636 16.5 22.8636C20.5668 22.8636 23.8636 19.5668 23.8636 15.5C23.8636 11.4332 20.5668 8.13636 16.5 8.13636ZM7.5 15.5C7.5 10.5294 11.5294 6.5 16.5 6.5C21.4706 6.5 25.5 10.5294 25.5 15.5C25.5 20.4706 21.4706 24.5 16.5 24.5C11.5294 24.5 7.5 20.4706 7.5 15.5Z",
    fill: "url(#paint0_linear_3163_1280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3623 11.9545C15.4968 11.9545 14.8011 12.4049 14.4947 12.9788C14.282 13.3775 13.7863 13.5282 13.3877 13.3154C12.989 13.1026 12.8384 12.607 13.0511 12.2084C13.6645 11.0592 14.9421 10.3182 16.3623 10.3182C18.3044 10.3182 20.0457 11.7393 20.0457 13.6865C20.0457 15.0018 19.232 16.0948 18.1225 16.6467C17.4755 16.9686 17.1805 17.3746 17.1805 17.6818C17.1805 18.1337 16.8142 18.5 16.3623 18.5C15.9105 18.5 15.5442 18.1337 15.5442 17.6818C15.5442 16.3928 16.6115 15.5707 17.3937 15.1816C18.0375 14.8614 18.4093 14.286 18.4093 13.6865C18.4093 12.817 17.585 11.9545 16.3623 11.9545Z",
    fill: "url(#paint1_linear_3163_1280)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2638 20.3545C17.2638 20.8064 16.8975 21.1727 16.4456 21.1727C15.9938 21.1727 15.6274 20.8064 15.6274 20.3545C15.6274 19.9027 15.9938 19.5364 16.4456 19.5364C16.8975 19.5364 17.2638 19.9027 17.2638 20.3545Z",
    fill: "url(#paint2_linear_3163_1280)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3163_1280",
    x1: 8.5,
    y1: 9,
    x2: 23,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3163_1280",
    x1: 13.3485,
    y1: 11.4545,
    x2: 19.7388,
    y2: 16.2289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3163_1280",
    x1: 15.7184,
    y1: 19.7636,
    x2: 17.0365,
    y2: 20.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AE276"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltiphover);
export default __webpack_public_path__ + "static/media/tooltiphover.4861883cceb66ec2166528e1f5715411.svg";
export { ForwardRef as ReactComponent };